import React  from 'react';
import {Buttons} from '../../elements/ui/index';
import Ionicon from "react-ionicons";

export const Industry = (props) => {
    const {primary_industry, buttonHandlers, guestMode} = props,
        primaryIndustryExists = primary_industry && primary_industry.hasOwnProperty('name');
    return (
        <div className="profile-industry">
            {  primaryIndustryExists && <span className="user-info"><b>Main industry:</b> <br />{ primary_industry.name }</span> }
            {/*show when not in guestMode*/}
            { !guestMode && <Buttons.HOCButton
                text={ primaryIndustryExists ? <Ionicon icon="ion-edit"/> : <em>Add your main industry...</em>}
                icon=""
                { ...buttonHandlers }
            /> }
        </div>
    )
};

export default Industry;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/Industry.js